import { useState } from 'react';
import classnames from 'classnames';
import ClipboardIcon from '@scramble/design-system/icons/copy-06.svg?react';
import s from './index.module.scss';

export const CopyButton = ({ text, onSuccess, onFailure }) => {
  const [isCopied, setIsCopied] = useState(false);

  const onClick = () => {
    setIsCopied(true);
    navigator.clipboard.writeText(text).then(onSuccess, onFailure);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={classnames(
        s.button,
        isCopied ? s.button_copied : s.button_copy,
      )}
      onMouseLeave={() => setIsCopied(false)}
    >
      <ClipboardIcon />
    </button>
  );
};